module.exports = __webpack_public_path__ + "assets/img/37_1526.57d3cacc.jpg";